import { useMemo } from "react";
import { joinLine, leaveLine } from "./ws-client";
import { useSocketEffect } from "./use-socket-effect";

// Room membership por linha.
// O servidor re-emite SÓ para rooms `line:<id>` (não há room global): um socket
// conectado que não entrou em nenhum room não recebe evento algum. As telas ao vivo
// passam os ids das linhas visíveis; este hook entra/sai dos rooms conforme o conjunto
// muda, e — via useSocketEffect — RELIGA quando o socket aparece ou troca (ex.: a tela
// montou antes do AppLayout criar o socket) e reentra a cada (re)connect (rooms são
// por-conexão). Ver research R-03.
export function useRealtimeRooms(lineIds: string[]): void {
  // Conjunto ordem-insensível como string estável: re-roda o efeito só quando o
  // conjunto de ids MUDA de fato (refetch com os mesmos ids não causa churn). Memoizado
  // para não realocar Set+sort+join a cada render do pai.
  const key = useMemo(
    () =>
      Array.from(new Set(lineIds.filter(Boolean)))
        .sort()
        .join(","),
    [lineIds]
  );

  useSocketEffect(
    (socket) => {
      if (!socket) return;
      const desired = key ? key.split(",") : [];
      if (desired.length === 0) return;

      const joinAll = () => {
        for (const id of desired) joinLine(id);
      };
      // Entra agora se já conectado, e (re)entra a cada (re)connect — as rooms do
      // Socket.IO são por-conexão e se perdem ao desconectar. `socket.join` é idempotente.
      if (socket.connected) joinAll();
      socket.on("connect", joinAll);

      return () => {
        socket.off("connect", joinAll);
        for (const id of desired) leaveLine(id);
      };
    },
    [key]
  );
}
